import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

const EmailLayout = Loadable(
  lazy(() =>
    import("./EmailLayout").then(({ EmailLayout }) => ({
      default: EmailLayout,
    })),
  ),
);

const EmailInbox = Loadable(
  lazy(() =>
    import("./EmailInbox/EmailInbox").then(({ EmailInbox }) => ({
      default: EmailInbox,
    })),
  ),
);

const EmailWindowLayout = Loadable(
  lazy(() =>
    import("./EmailWindowLayout").then(({ EmailWindowLayout }) => ({
      default: EmailWindowLayout,
    })),
  ),
);
const OutlookEventsCalender = Loadable(
  lazy(() =>
    import("./Components/OutlookEventsCalender/OutlookEventsCalender").then(({ OutlookEventsCalender }) => ({
      default: OutlookEventsCalender,
    })),
  ),
);

export const emailRoutes = {
  path: "/api/v1/",
  exact: true,
  element: (
    <AuthorizedRoute moduleKeys={[]} allowFullAccess>
      <EmailLayout />
    </AuthorizedRoute>
  ),
  children: [
    {
      path: "portal",
      element: <EmailWindowLayout />,
      children: [{ path: "inbox", element: <EmailInbox /> },{ path: "calendar", element: <OutlookEventsCalender /> }],
    },
  ],
};
